export default __webpack_public_path__ + "static/media/instagram.d19b64c2.png";